import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { ThumbsDown } from "@faire/web/slate/icons/foundation/ThumbsDown";
import { ThumbsUp } from "@faire/web/slate/icons/foundation/ThumbsUp";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled, { css } from "styled-components";
import { trackCsatClick } from "./utils";
export var YesNoButtons = function YesNoButtons(_ref) {
  var visibleWhen = _ref.visibleWhen,
    value = _ref.value,
    onChange = _ref.onChange,
    brandOrRetailerToken = _ref.brandOrRetailerToken,
    issue = _ref.issue;
  if (!visibleWhen) {
    return null;
  }
  var yesVariant = value === "Yes" ? "primary" : "secondary";
  var noVariant = value === "No" ? "primary" : "secondary";
  var handleClickOn = function handleClickOn(isUseful) {
    trackCsatClick(brandOrRetailerToken, issue, isUseful);
    onChange(isUseful);
  };
  return /*#__PURE__*/React.createElement(WrapperColumn, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nF/CkR",
    defaultMessage: [{
      "type": 0,
      "value": "Heeft dit geholpen?"
    }]
  }))), /*#__PURE__*/React.createElement(Row, {
    gap: 10
  }, /*#__PURE__*/React.createElement(StyledButton, {
    variant: yesVariant,
    onClick: function onClick() {
      return handleClickOn("Yes");
    }
  }, /*#__PURE__*/React.createElement(ThumbsUp, {
    fontSize: "16px"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "sEBTfL",
    defaultMessage: [{
      "type": 0,
      "value": "Ja"
    }]
  }))), /*#__PURE__*/React.createElement(StyledButton, {
    variant: noVariant,
    onClick: function onClick() {
      return handleClickOn("No");
    }
  }, /*#__PURE__*/React.createElement(ThumbsDown, {
    fontSize: "16px"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rA2lbg",
    defaultMessage: [{
      "type": 0,
      "value": "Nee"
    }]
  })))));
};
var WrapperColumn = styled(Column).attrs({
  gap: "1x"
}).withConfig({
  displayName: "YesNoButtons__WrapperColumn"
})([""]);
var StyledButton = styled(Button).withConfig({
  displayName: "YesNoButtons__StyledButton"
})(["display:flex;align-items:center;justify-content:center;gap:", ";padding:", ";height:", ";", ";&:hover *{color:", ";}"], getSpacing("1x"), getSpacing("0", "3x"), getSpacing("5x"), function (props) {
  return props.variant === "primary" ? css(["*{color:", ";}"], Core.surface.inverse) : null;
}, Core.surface.inverse);